import { render, staticRenderFns } from "./NewOrderTableRow.vue?vue&type=template&id=0ef47408&scoped=true&"
import script from "./NewOrderTableRow.vue?vue&type=script&lang=js&"
export * from "./NewOrderTableRow.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderTableRow.vue?vue&type=style&index=0&id=0ef47408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef47408",
  null
  
)

export default component.exports